<template>
  <van-pull-refresh v-model="isLoading"  style="min-height: 80vh;"  @refresh="onRefresh">
    <div  style="padding:4px 10px;width:100%;  display: flex;
  flex-wrap: wrap;">
      <div class="recom_list" v-for="(item) in myMenuList"
                @click.stop="editInfo(item.cookbookId, 'detailMenu')"
                :key="item.cookbookId">
                    <van-image
                        fit="cover"
                        :src="item.cookbookUrl?item.cookbookUrl:require('@/assets/头像图片.png') "
                      />
            <div style="padding:6px 10px">
               <p style="margin-bottom:4px" class="text_ccc">{{item.name}}</p>
                  <div>
                      <span class="text_ccc fSize_12">{{item.estimateTime}}分钟</span>
                      <span class="float_right text_yellow" >￥{{ item.unitPrice | filterNumTwo }}
                          <span class="fSize_10 text_yellow">/份</span>
                      </span>
                    </div>
            </div>
      </div>
    </div>
  </van-pull-refresh>
</template>
<script>
export default {
  components: {},
  created() {
    this.cusCookbookList();
  },
  data() {
    return {
      myMenuList: [],
      isLoading: false,
      url: "@/assets/img/菜品-1.png"
    };
  },
  mounted() {
    // document.getElementById("meun").addEventListener("touchmove", e => {
    //   e.preventDefault();
    // });
  },
  methods: {
    editInfo(cookbookId, opeation) {
      this.$router.push({
        path: `/menuList/${opeation}`,
        query: {
          cookbookId,
          remark: "recom"
        }
      });
    },
    onRefresh() {
      this.isLoading = true;
      this.$axios
        .post("trade/tradeCookbook/list", {
          status: 0
        })
        .then(res => {
          this.myMenuList = res.data.data;
          this.isLoading = false;
          this.$toast("刷新成功");
        });
    },
    ///tradeCookbook/customerList
    cusCookbookList() {
      this.$axios
        .post("trade/tradeCookbook/list", {
          status: 0
        })
        .then(res => {
          this.myMenuList = res.data.data;
        });
    },
    removeInfo(id) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除？",
          confirmButtonColor: "#74b42b"
        })
        .then(() => {
          // on confirm
          this.$axios.delete(`trade//tradeCookbook/${id}`).then(() => {
            this.cusCookbookList();
            this.$toast.success("删除成功");
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    addMenu() {
      ///orderList/send
      this.$router.push({
        path: "/menuList/addMenu"
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.index {
  padding-top: 120px;
  transition: all 1s;
  background: rgba(242, 242, 242, 1);
  padding-bottom: 60px;
}
.addBtn.van-button--large {
  height: 40px;
  border: 1px dashed rgb(116, 180, 43);
  color: rgb(116, 180, 43);
}
.addBtn.van-hairline--surround::after {
  border: none;
}
.btnEdit /deep/ .van-button {
  padding: 0 16px;
}
.recom_list {
  width: 46%;
  // background-image: url(imgs/矩形备份3.png);
  box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  border-radius: 10px;
  box-sizing: border-box;
  background-color: #fff;
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  margin: 2px 11px 10px 0;
  /deep/ .van-image {
    width: 100%;
    height: 172px;
    .van-image__img {
      border-radius: 10px;
    }
  }
}
</style>